<template>
  <div>
    <v-container>
      <v-form v-model="valid">
        <v-col xs="12" lg="6">
          <v-card>
            <v-card-title>Upload preorders CSV</v-card-title>
            <v-card-text>
              <v-row>
                <v-col xs="12" lg="8">
                  <v-file-input label="Preorders CSV" v-model="preordersCsvFile"
                                :hide-details="auto" class="mb-2"
                  ></v-file-input>
                </v-col>
                <v-col xs="12" lg="4">
                  <v-select
                      :items="warehouseChoices"
                      v-model="warehouse"
                      outlined
                      dense
                      label="Warehouse"
                      placeholder="Select warehouse"
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>
            <v-col xs="12" lg="2">
              <v-btn color="primary" class="d-flex .justify-end" @click="saveIncomingStockData">Save</v-btn>
            </v-col>

          </v-card>

        </v-col>
      </v-form>
    </v-container>
  </div>
</template>

<script>
  import {getCookie} from '@/helpers/getCookie.js'

  const axios = require('axios')

  export default {
    name: "IncomingStock",
    data() {
      return {
        preordersCsvFile: null,
        base64Csv: "",
        warehouse: null,
        warehouseChoices: [],
      }
    },
    mounted() {
      this.fetchWarehousesChoices()
    },
    methods: {
      redirectToLogin() {
        this.$router.push({name: 'login'})
      },
      async convertCsvToBase64(funcToCall) {
        console.log("TEST 1")
        var file = this.preordersCsvFile
        console.log(file.name)
        console.log(file.type)
        const reader = new FileReader();
        reader.addEventListener("load", function () {
          var b64Csv = reader.result
          funcToCall(b64Csv)
        }, false)
        reader.readAsDataURL(file);
        console.log("Called reader")
      },
      async saveIncomingStockData() {
        this.convertCsvToBase64(this.sendDataToManager)
      },
      sendDataToManager(b64Csv) {
        var requestData = {
          incoming_shipments_csv: b64Csv,
          warehouse: this.warehouse
        }
        console.log(requestData)
        let redirectToLoginFunction = this.redirectToLogin
        var url = "/api/incoming_stock/"
        axios.post(url, requestData, {
          headers: {
            "X-CSRFToken": getCookie("csrftoken")
          },
        }).then(console.log("OK")).catch(function (error) {
          if (403 === error.response.status) {
            alert("Failed to obtain data")
            redirectToLoginFunction()
          }
        })
      },
      fetchWarehousesChoices() {
        var url = "/api/warehouses/"
        axios.get(url).then(this.setStatusChoices)
      },
      setStatusChoices(response){
        var warehouses = response.data.results
        var parsedChoices = []
        for (var i = 0; i < warehouses.length; i++) {
          var choice = warehouses[i]
          var parsedChoice = {
            text: choice.name,
            value: choice.id,
          }
          parsedChoices.push(parsedChoice)
        }
        this.warehouseChoices = parsedChoices
      }

    }
  }
</script>

<style scoped>

</style>